(function() {
  const ultraMultiplyer = 1.10;
  const legendaryMultiplyer = 1.20;

  window.playingCards = {
    
    shuffleArray: function(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    getCardsStats: function(cards, abilities) {
      for (let card of cards) {
        card = playingCards.getCardStats(card, abilities);
      }
      return cards;
    },

    getCardStats: function(card, abilities) {

      if (card.hp == Number(0)) {
        card.maxStamina = 0;
        card.maxMana = 0;
        card.currentStamina = 0;
        card.currentMana = 0;
        return card;
      }

      // Legacy stats (kept for backwards compatibility)
      card.accuracy = Number(card.accuracy);
      card.attack = Number(card.attack);
      card.defence = Number(card.defence);
      card.hp = Number(card.hp);
      card.originalHp = Number(card.hp);
      card.speed = Number(card.speed);
      card.tier = Number(card.tier);

      // New battle stats
      card.pAtk = Number(card.pAtk) || card.attack;
      // Default mAtk to 50% of attack if not set or explicitly 0 (matches database migration)
      const mAtkValue = (card.mAtk !== null && card.mAtk !== undefined && card.mAtk !== '') 
        ? Number(card.mAtk) 
        : 0;
      card.mAtk = (mAtkValue === 0 && card.pAtk > 0) 
        ? Math.round(card.pAtk * 0.5) 
        : mAtkValue;
      card.armor = Number(card.armor) || card.defence;
      // Default ward to 50% of defence if not set or explicitly 0 (matches common pattern)
      const wardValue = (card.ward !== null && card.ward !== undefined && card.ward !== '') 
        ? Number(card.ward) 
        : 0;
      const armorValue = Number(card.armor) || card.defence;
      card.ward = (wardValue === 0 && armorValue > 0) 
        ? Math.round(armorValue * 0.5) 
        : wardValue;
      card.critChance = Number(card.critChance) || 5;
      card.critDamage = Number(card.critDamage) || 150;

      // Calculate stamina and mana based on attack types
      const pAtk = Number(card.pAtk) || Number(card.attack) || 0;
      const mAtk = Number(card.mAtk) || 0;

      // If card has specific stamina/mana values, use them, otherwise calculate based on attack type
      if (card.stamina !== undefined && card.stamina !== null) {
        card.maxStamina = Number(card.stamina);
      } else {
        // Stamina scales with physical attack (0 if pure magic user)
        card.maxStamina = pAtk > 0 ? 100 : 0;
      }

      if (card.mana !== undefined && card.mana !== null) {
        card.maxMana = Number(card.mana);
      } else {
        // Mana scales with magic attack (0 if pure physical user)
        card.maxMana = mAtk > 0 ? 100 : 0;
      }

      card.currentStamina = card.maxStamina;
      card.currentMana = card.maxMana;

      // Legacy critical chance (kept for backwards compatibility with abilities)
      card.criticalChance = card.critChance;
      card.move = 1;
      card.turnSkips = 0;
      card.activeTraits = {};

      if (card.cardId) {
        card.image = `${root}/images/cards/${card.cardId}.png`;
      }

      // If the server already supplied abilityKey (UUID), keep it and just resolve the display name.
      // Otherwise fall back to looking up card.ability as a UUID key in the abilities map.
      if (card.abilityKey && abilities && abilities[`${card.abilityKey}`]) {
        card.ability = abilities[`${card.abilityKey}`].name;
      } else if (abilities && card.ability && abilities[`${card.ability}`]) {
        card.abilityKey = card.ability;
        card.ability = abilities[`${card.ability}`].name;
      }

      // Resolve attack trait: map DB UUID → internal slug used by traits.apply()
      if (window.traits && typeof traits.resolveSlug === 'function') {
        const traitId = card.trait || card.traitSlug;
        if (traitId) {
          const slug = traits.resolveSlug(traitId);
          if (slug) { card.traitSlug = slug; }
        }
      }

      if (card.tier == 2) {
        card = playingCards.increaseCardStats(card, ultraMultiplyer);
      } else if (card.tier == 3) {
        card = playingCards.increaseCardStats(card, legendaryMultiplyer);
      }
      return card;
    },

    increaseCardStats: function(card, val) {
      // Legacy stats
      card.attack = Math.round(card.attack * val);
      card.hp = Math.round(card.hp * val);
      card.originalHp = card.hp;
      //card.accuracy = Math.round(card.accuracy * val);
      card.defence = Math.round(card.defence * val);
      card.speed = Math.round(card.speed * val);

      // New battle stats (multiplied by tier)
      card.pAtk = Math.round(card.pAtk * val);
      card.mAtk = Math.round(card.mAtk * val);
      card.armor = Math.round(card.armor * val);
      card.ward = Math.round(card.ward * val);
      // Note: critChance, critDamage, stamina, mana are NOT multiplied by tier

      return card;
    },

    groupCardsByTier: function(array) {
      let cards = {
        'exotic': [],
        'ultimate': [],
        'variant': [],
        'legendary': [],
        'ultra': [],
        'normal': []
      };

      if (!Array.isArray(array)) return cards;

      // Ultimate cards get added as is, but all other cards get copies added with stat boosts for each tier
      for (let i = 0; i < array.length; i++) {
        let card = array[i];
        if (card.ultimate) {
          card.tier = 4;
          cards['ultimate'].push(card);

          let ultimateNormalCopy = Object.assign({}, card);
          ultimateNormalCopy.tier = 1;
          cards['normal'].push(ultimateNormalCopy);

          let ultimateUltraCopy = Object.assign({}, card);
          ultimateUltraCopy.tier = 2;
          cards['ultra'].push(ultimateUltraCopy);

          let ultimateLegendaryCopy = Object.assign({}, card);
          ultimateLegendaryCopy.tier = 3;
          cards['legendary'].push(ultimateLegendaryCopy);
        } else if (card.exotic) {
          card.tier = 8;
          cards['exotic'].push(card);
        } else if (card.variant) {
          card.tier = 9;
          cards['variant'].push(card);
        } else {
          card.tier = 1;
          cards['normal'].push(card);
    
          let ultraCopy = Object.assign({}, card);
          ultraCopy.tier = 2;
          cards['ultra'].push(playingCards.increaseCardStats(ultraCopy, ultraMultiplyer));
    
          let legendaryCopy = Object.assign({}, card);
          legendaryCopy.tier = 3;
          cards['legendary'].push(playingCards.increaseCardStats(legendaryCopy, legendaryMultiplyer));
        }
      }
      
      return cards;
    },

    inventory: function(boneCards){
      playingCards.getBoneCard(boneCards)
    },
    cardUpgrade: function(){

    },
    openPack: function(pack, allCards, boneCards, ascensionCard, deltaCards) {
      const allCardsByTier = playingCards.groupCardsByTier(allCards);
      let packSize = pack.size;

      cards = [];

      if (pack.legendaryGuaranteed) {
        cards.push(playingCards.getCard(allCardsByTier, pack, 'legendary'));
        packSize--;
      }

      if (pack.ultraGuaranteed) {
        cards.push(playingCards.getCard(allCardsByTier, pack, 'ultra'));
        packSize--;
      }

      if (pack.exoticGuaranteed) {
        cards.push(playingCards.getCard(allCardsByTier, pack, 'exotic'));
        packSize--;
      }

      if (pack.variantGuaranteed) {
        cards.push(playingCards.getCard(allCardsByTier, pack, 'variant'));
        packSize--;
      }

      if(pack.boneCardGuaranteed){
        const boneChance = Number(pack.boneCardChance);
        if(boneChance >= 100){
          for(let i = 0; i < packSize; i++){
            cards.push(playingCards.getBoneCard(boneCards, pack));
          }
          packSize = 0;
        } else {
          let randomNumber = Math.random() * 100;
          if(randomNumber < boneChance){
            cards.push(playingCards.getBoneCard(boneCards, pack));
            packSize--;
          }
        }
      }

      if(pack.deltaGuaranteed && deltaCards && Object.keys(deltaCards).length > 0){
        let randomNumber = Math.random() * 100;
        if(randomNumber < Number(pack.deltaChance)){
          cards.push(playingCards.getDeltaCard(deltaCards, pack));
          packSize--;
        }
      }

      let randomNumber = Math.random() * 100;

      if(randomNumber < Number(pack.ascChance)){
        cards.push(playingCards.getAscension(ascensionCard, pack));
        packSize--;
      }

      if(deltaCards && Object.keys(deltaCards).length > 0){
        let deltaRandomNumber = Math.random() * 100;
        if(deltaRandomNumber < Number(pack.deltaChance)){
          cards.push(playingCards.getDeltaCard(deltaCards));
          packSize--;
        }
      }

      for (let i = 0; i < packSize; i++) {
        cards.push(playingCards.getCard(allCardsByTier, pack, null, null, deltaCards));
      }

      playingCards.shuffleArray(cards);

      return cards;
    },


    getCard: function(cards, pack, tier, cardId, deltaCards) {
      //get current card
      if(cardId){
       return cards[tier].find(item => item.id === cardId);
      }
      //get a card by tier
      if (tier) {
        const pool = cards[tier];
        if (!pool || pool.length === 0) {
          console.warn(`⚠️ No cards in pool for tier: ${tier} — falling back to normal`);
          const fallback = cards['normal'];
          return fallback.length ? fallback[Math.floor(Math.random() * fallback.length)] : null;
        }
        return pool[Math.floor(Math.random() * pool.length)];
      }
     
      
      const num = Math.random() * 100;
      let index;

      let ultimateChance = Number(pack.ultimateChance) || 0;
      let legendaryChance = Number(pack.legendaryChance) || 0;
      let ultraChance = Number(pack.ultraChance) || 0;
      let exoticChance = Number(pack.exoticChance) || 0;
      let deltaChance = Number(pack.deltaChance) || 0;
      let variantChance = Number(pack.variantChance) || 0;

      let cumulative = 0;

      if (num < (cumulative += ultimateChance)) {
        index = Math.floor(Math.random() * cards['ultimate'].length);
        return cards['ultimate'][index];
      } else if (num < (cumulative += legendaryChance)) {
        index = Math.floor(Math.random() * cards['legendary'].length);
        return cards['legendary'][index];
      } else if (num < (cumulative += ultraChance)) {
        index = Math.floor(Math.random() * cards['ultra'].length);
        return cards['ultra'][index];
      } else if (exoticChance > 0 && num < (cumulative += exoticChance)) {
        index = Math.floor(Math.random() * cards['exotic'].length);
        return cards['exotic'][index];
      } else if (deltaChance > 0 && deltaCards && Object.keys(deltaCards).length > 0 && num < (cumulative += deltaChance)) {
        return playingCards.getDeltaCard(deltaCards);
      } else if (variantChance > 0 && num < (cumulative += variantChance)) {
        index = Math.floor(Math.random() * cards['variant'].length);
        return cards['variant'][index];
      } else {
        index = Math.floor(Math.random() * cards['normal'].length);
        return cards['normal'][index];
      }
      
    },
    getBoneCard: function(cards) {
      let boneCards = Object.values(cards);
    

      index = Math.floor(Math.random() * 6);

      return boneCards[index];
      
    },
    getAscension: function(cards) {

      let asc = Object.values(cards);

      return asc[0];

    },
    getDeltaCard: function(cards) {

      let delta = Object.values(cards);
      let card = Object.assign({}, delta[Math.floor(Math.random() * delta.length)]);
      card.deltaCard = true;
      return card;

    }
  }
})();